import type { WidgetEffectParams } from '@swf/core/store';
import { pageChange } from '@swf/core/utils/actions';
import type { BasicSportsWidgetConfig } from '@swf/sports/pages/types';
import buildSportsRequest from '@swf/sports/utils/buildSportsRequest';
import getErrorStatusCode from '@swf/sports/utils/getErrorStatusCode';
import { getWidgetCancellationSignal } from '@swf/sports/utils/getWidgetCancellationSignal';
import { hasRequestAborted } from '@swf/sports/utils/hasRequestAborted';

import type { MappedRaceMeetings, WidgetDispatch, WidgetSelect } from './types';

export const effects = {
  async preload(
    _payload: undefined,
    { dispatch, widget, select, rootState, actions }: WidgetEffectParams<BasicSportsWidgetConfig>
  ) {
    const { meetingsRequested, clear }: WidgetDispatch = dispatch[widget.uid];
    const { hasPreloaded }: WidgetSelect = select[widget.uid];

    pageChange(actions)?.subscribe(meetingsRequested);

    widget.unmount.subscribe(clear);

    if (!hasPreloaded(rootState)) {
      await meetingsRequested();
    }
  },
  async meetingsRequested(
    _payload: undefined,
    params: WidgetEffectParams<BasicSportsWidgetConfig>
  ) {
    const { dispatch, request, widget, rootState, select } = params;
    const { eventTypeId } = select.sports.getUrlParams(rootState);
    const { meetingsLoadSuccess, meetingsLoadFailure }: WidgetDispatch = dispatch[widget.uid];
    const sportsRequest = buildSportsRequest(request, rootState);

    try {
      const {
        body: { data }
      } = await sportsRequest<{ data: MappedRaceMeetings }>({
        path: `/race-meetings/${eventTypeId}`,
        signal: getWidgetCancellationSignal(params)
      });
      meetingsLoadSuccess(data);
    } catch (error) {
      if (hasRequestAborted(error)) return;
      meetingsLoadFailure(getErrorStatusCode(error));
    }
    return;
  }
};
